import { IMonitoringFormControlsResolver } from 'src/features/generalForms/monitoringForms/IMonitoringFormControlsResolver';
import { RootContainer, Container } from '../generalForms/reportComponents/containers';
import { TextBlock, FormDividingLine, ImageBlock } from '../generalForms/reportComponents/content';
import {
  FormTextInput,
  FormMultipleTextInput,
  FormNumberInput,
  FormSliderInput,
  FormDateInput,
  FormDateRangeInput,
  FormTimeInput,
  FormRadioGroupInput,
  FormDropDownInput,
  FormCheckboxGroupInput,
  FormMultipleDropdownInput,
  FormTagInput,
  FormFileInput,
} from '../generalForms/reportComponents/inputs';
import {
  RepeatableContainer,
  RepeatableSection,
} from '../generalForms/reportComponents/containers/repeatableContainer';

export const MonitoringFormReportControlsResolver: IMonitoringFormControlsResolver = {
  // Containers
  RootContainer: RootContainer,
  Container: Container,
  RepeatableContainer: RepeatableContainer,
  RepeatableSection: RepeatableSection,

  // Content
  FormText: TextBlock,
  FormDividingLine: FormDividingLine,
  FormImage: ImageBlock,

  // Inputs
  FormTextInput: FormTextInput,
  FormMultipleTextInput: FormMultipleTextInput,
  FormNumberInput: FormNumberInput,
  FormSliderInput: FormSliderInput,
  FormDateInput: FormDateInput,
  FormDateRangeInput: FormDateRangeInput,
  FormTimeInput: FormTimeInput,
  FormRadioGroupInput: FormRadioGroupInput,
  FormDropdownInput: FormDropDownInput,
  FormCheckboxGroupInput: FormCheckboxGroupInput,
  FormMultipleDropdownInput: FormMultipleDropdownInput,
  FormTagInput: FormTagInput,
  FormFileInput: FormFileInput,
};
